import { useCallback } from "react";
import { Megaphone } from "lucide-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import usePageTitle from "hooks/usePageTitle";
import CampaignService from "services/Campaign";
import NewCampaignButton from "routes/campaign/components/NewCampaignButton";
import _BatchEditCampaignModal from "./components/BatchEditCampaignModal";
import {
  invalidateCampaignsQuery,
  useCampaignTable,
} from "hooks/useCampaignTable";
import { getNextQueryParams } from "components/helpers";
import BaseTableV3 from "components/BaseTableV3/BaseTableV3";
import withRoleCheck from "components/hocs/withRoleCheck";
import CONSTANTS from "constants/Constants";

export const CAMPAIGNS_TABLE_CONSTANTS = {
  headerIcon: Megaphone,
  header: "Campaigns",
  tableName: "campaigns",
  queryKey: "campaigns",
  className: "Campaign",
  exportTableName: "CampaignsTable",
};

const defaultFilters = {
  status: [CONSTANTS.CAMPAIGN_STATUS_TYPES.ACTIVE],
};

const BatchEditCampaignModal = withRoleCheck(_BatchEditCampaignModal, [
  ACL_RELATIONSHIPS.statusInCampaign.edit,
]);

const batchEditButton = ({ selectedIds = [], uncheckAll }) => {
  const handleFinish = async () => {
    uncheckAll();
    await invalidateCampaignsQuery();
  };

  return (
    <BatchEditCampaignModal
      campaigns={selectedIds}
      finishBatchEdit={handleFinish}
    />
  );
};

const CampaignsTableV3 = () => {
  usePageTitle(CAMPAIGNS_TABLE_CONSTANTS.header);

  const { filters, columns, customFields } = useCampaignTable();

  const fetchCampaigns = useCallback(
    async queryParams => {
      try {
        const nextQueryParams = getNextQueryParams(queryParams, columns);

        const response =
          await CampaignService.getCampaignsTable(nextQueryParams);
        return response;
      } catch (error) {
        console.error("Error fetching campaigns:", error);
        throw error;
      }
    },
    [columns]
  );

  return (
    <BaseTableV3
      columns={columns}
      filters={filters}
      customFields={customFields}
      defaultFilters={defaultFilters}
      headerIcon={CAMPAIGNS_TABLE_CONSTANTS.headerIcon}
      header={CAMPAIGNS_TABLE_CONSTANTS.header}
      tableName={CAMPAIGNS_TABLE_CONSTANTS.tableName}
      queryKey={CAMPAIGNS_TABLE_CONSTANTS.queryKey}
      className={CAMPAIGNS_TABLE_CONSTANTS.className}
      exportTableName={CAMPAIGNS_TABLE_CONSTANTS.exportTableName}
      createButton={<NewCampaignButton />}
      batchEditButton={batchEditButton}
      fetchData={fetchCampaigns}
      invalidateData={invalidateCampaignsQuery}
      enableSearch
      enableSettings
    />
  );
};

export default CampaignsTableV3;
